import {APIError} from '../core/errors';
import {
  employeePasswordResponse,
  employeeResetPasswordRequest,
  employeeTempPasswordRequest,
} from '../lib/types';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';
//todo
//add new const api_base_url
const _api_base_url1 = `${BASE_URL}/employee/reset-password`;
const _api_base_url2 = `${BASE_URL}/employee/change-password`;

// TODO: remove later
export const employeeresetpasswordapicall = async (
  parameters: employeeResetPasswordRequest,
): Promise<employeePasswordResponse> => {
  //todo
  // dob has to be non mandatory

  try {
    const response = await httpClient.post(`${_api_base_url2}`, parameters, {
      headers: {
        ...DEFAULT_HEADERS,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
export const employeeforgetpasswordapicall = async (
  parameters: employeeTempPasswordRequest,
): Promise<employeePasswordResponse> => {
  //todo
  // dob has to be non mandatory

  try {
    const response = await httpClient.post(`${_api_base_url1}`, parameters, {
      headers: {
        ...DEFAULT_HEADERS,
      },
    });
    return response.data;
  } catch (error) {
    console.error(error);
    throw new APIError(error);
  }
};
